export default __webpack_public_path__ + "static/media/20.13ee917f.jpg";